import { Link } from '@hub/link'
import { Pill } from '@hub/pill'
import LinkReel from '@scentregroup/shared/hub-components/link-reel'
import React from 'react'

export const SubCategoriesReel: React.FC<{
  items: {
    key: string
    link: string
    isSelected: boolean
    title: string
  }[]
}> = ({ items }) => {
  return (
    <LinkReel gap="spacing-md" sx={{ height: '1.75em' }}>
      {items.map(item => (
        <Link key={item.key} href={item.link} sx={{ flexGrow: 0 }}>
          <Pill colorScheme={item.isSelected ? 'licorice' : 'ghost'}>
            {item.title}
          </Pill>
        </Link>
      ))}
    </LinkReel>
  )
}
